import React, { useEffect, useState } from 'react';
import {
  Alert,
  Text,
  TextInput,
  View,
  ScrollView,
  Pressable,
  StyleSheet,
  Linking,
  ActivityIndicator,
  Platform,
  ActionSheetIOS,
} from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import mystyles from '../../assets/styles/mystyles';
import {
  callApi,
  callPhone,
  formatDate,
  getLatLong,
  getTimeMs,
  getUserAddress,
  getUserIdEmailPhone,

  performFollow,
  setCurrentZipCode,
} from '../Helper/Helper';
import UserZipcode from '../Helper/UserZipcode';
import Geolocation from 'react-native-geolocation-service';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {SafeAreaView} from 'react-native-safe-area-context';

const Live = ({zipinput}) => {
  const navigation = useNavigation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [followBusy, setFollowBusy] = useState({}); // per-row loading state
  const [cUserId, setCUserId] = useState(null);
  const [cEmail, setCEmail] = useState(null);
  const [cPhone, setCPhone] = useState(null);
  const [zipcode, setZipcode] = useState(null);
  const [isEditingZip, setIsEditingZip] = useState(false);
  const [zipDraft, setZipDraft] = useState('');

  useEffect(() => {
    (async () => {
      try{
        const {userId,email,phone} = await getUserIdEmailPhone();
        setCUserId(userId);
        // Map to your state shape
        setCEmail(email ?? '');
        setCPhone(phone ?? '');
      } catch (e) {
        console.warn('Failed to get user info', e);
      }
    })();
  }, []);

  const handleFollow = async (item, rowKey) => {
    await performFollow(item, cUserId, cEmail, cPhone, setFollowBusy, rowKey);
  };

  const handleContactPress = (phoneNumber) => {
    if (Platform.OS === 'ios') {
      ActionSheetIOS.showActionSheetWithOptions(
        {
          options: ['Cancel', 'Call', 'Text Message'],
          cancelButtonIndex: 0,
          title: phoneNumber, // Showing number as title confirms context
        },
        (buttonIndex) => {
          if (buttonIndex === 1) Linking.openURL(`tel:${phoneNumber}`);
          if (buttonIndex === 2) Linking.openURL(`sms:${phoneNumber}`);
        }
      );
    } else {
      // Android
      Alert.alert(
        phoneNumber,
        'Select an action',
        [
          { text: 'Cancel', style: 'cancel' },
          { text: 'Message', onPress: () => Linking.openURL(`sms:${phoneNumber}`) },
          { text: 'Call', onPress: () => Linking.openURL(`tel:${phoneNumber}`) },
        ],
        { cancelable: true }
      );
    }
  };

  const handleZipChangePress = () => {
    setZipDraft(zipcode ?? '');
    setIsEditingZip(true);
  };

  const handleZipSubmit = async () => {
    const nextZip = zipDraft.trim();
    if (!nextZip) {
      Alert.alert('Enter a ZIP code', 'Please enter a valid ZIP code.');
      return;
    }

    try {
      setLoading(true);
      await setCurrentZipCode(nextZip);
      setZipcode(nextZip);
      const json = await callApi('GET', '/eabu-live-consumer/' + nextZip + '/NA');
      setData(json);
      setError(null);
      setIsEditingZip(false);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (zipinput) {
        try {
          setZipcode(zipinput);
          const json = await callApi('GET', '/eabu-eat-consumer/' + zipinput + '/NA');
          setData(json);
        } catch (e) {
          setError(e);
        } finally {
          setLoading(false);
        }
      } else {
        // Check AsyncStorage first
        const storedZip = await AsyncStorage.getItem('session_zipcode');
        if (storedZip) {
          try {
            setZipcode(storedZip);
            const json = await callApi('GET', '/eabu-eat-consumer/' + storedZip + '/NA');
            setData(json);
            setLoading(false);
            return; // Exit if found in storage
          } catch (e) {
            console.log('Error fetching with stored zip:', e);
          }
        }

      }
    };
    fetchData();
  }, [zipinput]);
  useEffect(() => {
    const fetchData = async () => {
      if(zipinput){
        try{
          setZipcode(zipinput);
          const json = await callApi('GET', '/eabu-live-consumer/'+ zipinput + '/NA');
          setData(json);
        } catch (e) {
          setError(e);
        } finally {
          setLoading(false);
        }
      }
      else{
        const storedZip = await AsyncStorage.getItem('session_zipcode');
        if (storedZip) {
          try {
              setZipcode(storedZip);
              const json = await callApi('GET', '/eabu-live-consumer/' + storedZip + '/NA');
              setData(json);
            setLoading(false);
            return; // Exit if found in storage
          } catch (e) {
            console.log('Error fetching with stored zip:', e);
          }
        }

      }
    };
    fetchData().then(r => {});
  }, [zipinput]);

  if (loading) {
    return (
      <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
        <ActivityIndicator size="large" color="#0000ff" />
      </View>
    );
  }

  if (error) return <Text>Error: {error.message}</Text>;
  const  dataObject = JSON.parse(JSON.stringify(data));
  const items = dataObject?.Items ?? [];
  const count = dataObject?.Count ?? items.length ?? 0;
  // Sort by createdAt/CreatedAt descending (newest first)
  const sortedItems = [...items].sort((a, b) => {
    const ta = getTimeMs(a?.CreatedAt ?? a?.createdAt);
    const tb = getTimeMs(b?.CreatedAt ?? b?.createdAt);
    return tb - ta;
  });

  const onHelpPress = (item) => {
    const itemId = item?.ID ?? item?.itemId ?? item?.pk ?? null;
    const userId = item?.userId ?? item?.userId ?? item?.pk ?? null;
    const title = item?.title ?? item?.service ?? '';
    const description = item?.description ?? '';

    navigation.navigate('OfferHelp', {
      from: 'Live Well', // or 'Move Forward'
      zip: zipcode,
      itemId,
      userId,
      title,
      description,
    });
  };

  if (count === 0) {
    return (
      <SafeAreaView>
        <View style={styles.emptyStateCard}>
          <Text style={styles.emptyStateTitle}>No Household requests yet</Text>
          <Text style={styles.emptyStateSubtitle}>
            near <Text style={styles.emptyStateZip}>{zipcode}</Text>
          </Text>
          <Pressable
            onPress={handleZipChangePress}
            accessibilityRole="button"
            hitSlop={6}>
            <Text style={styles.zipChangeLink}>Change ZIP</Text>
          </Pressable>
          <Text style={styles.emptyStateHint}>
            Try a nearby ZIP to see more options.
          </Text>
        </View>

        {isEditingZip && (
          <View style={styles.zipEditRow}>
            <TextInput
              style={styles.zipInput}
              placeholder="Enter ZIP code"
              value={zipDraft}
              onChangeText={setZipDraft}
              keyboardType="number-pad"
              maxLength={5}
            />
            <Pressable
              onPress={handleZipSubmit}
              style={({pressed}) => [
                styles.zipSubmitButton,
                pressed && styles.zipSubmitButtonPressed,
              ]}
              accessibilityRole="button">
              <Text style={styles.zipSubmitText}>Update</Text>
            </Pressable>
            <Pressable
              onPress={() => setIsEditingZip(false)}
              style={({pressed}) => [
                styles.zipCancelButton,
                pressed && styles.zipCancelButtonPressed,
              ]}
              accessibilityRole="button">
              <Text style={styles.zipCancelText}>Cancel</Text>
            </Pressable>
          </View>
        )}
      </SafeAreaView>
    );
  }
      return (
        <SafeAreaView>
          <ScrollView
            style={{ marginTop: 1 }}
            contentContainerStyle={{ alignContent: 'center', justifyContent: 'center' }}
            showsVerticalScrollIndicator={true}
          >
            {zipcode && (
              <View style={styles.zipHeader}>
                <Text style={styles.zipHeaderText}>
                  Household help requested around zip: {zipcode}
                </Text>
                <Pressable onPress={handleZipChangePress} accessibilityRole="button" hitSlop={6}>
                  <Text style={styles.zipChangeLink}>Change</Text>
                </Pressable>
              </View>
            )}
            {isEditingZip && (
              <View style={styles.zipEditRow}>
                <TextInput
                  style={styles.zipInput}
                  placeholder="Enter ZIP code"
                  value={zipDraft}
                  onChangeText={setZipDraft}
                  keyboardType="number-pad"
                  maxLength={5}
                />
                <Pressable
                  onPress={handleZipSubmit}
                  style={({pressed}) => [styles.zipSubmitButton, pressed && styles.zipSubmitButtonPressed]}
                  accessibilityRole="button"
                >
                  <Text style={styles.zipSubmitText}>Update</Text>
                </Pressable>
                <Pressable
                  onPress={() => setIsEditingZip(false)}
                  style={({pressed}) => [styles.zipCancelButton, pressed && styles.zipCancelButtonPressed]}
                  accessibilityRole="button"
                >
                  <Text style={styles.zipCancelText}>Cancel</Text>
                </Pressable>
              </View>
            )}
            {sortedItems.map((item, idx) => (
              <View
                key={item?.ID ?? String(idx)}
                style={[mystyles.card, idx % 2 === 1 && mystyles.cardAlt]}
              >
                {/* userId pill */}

                {/* Focused title/description (mirrors CEat layout) */}

                <View style={styles.focusedContent}>
                  {!!item?.title && (
                    <Text style={[mystyles.title, styles.focusedTitle]}>
                      {item.title}
                    </Text>
                  )}

                  {!!item?.description && (
                    <Text style={[mystyles.description, styles.focusedDescription]}>
                      {String(item.description).replace(/\s*\n+\s*/g, ' ').trim()}
                    </Text>
                  )}
                </View>

                <Text style={{ fontSize: 12, color: '#666' }}>
                  Posted: {formatDate(item?.CreatedAt ?? item?.createdAt)}
                </Text>

                {/* I can help row */}
                {String(item?.userId ?? '') !== String(cUserId ?? '') && (
                  <View style={styles.helpRow}>
                    <Text style={styles.userIdPill}>Posted by {item?.userId}</Text>

                    <Pressable
                      style={[mystyles.tinyButton]}
                      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
                      onPress={() => onHelpPress(item)}
                    >
                      <Text style={mystyles.tinyButtonText}>I can help</Text>
                    </Pressable>
                  </View>
                )}
              </View>
            ))}
          </ScrollView>
        </SafeAreaView>
      );
    };

    const styles = StyleSheet.create({
      userIdContainer: {
        alignItems: 'center',
        marginBottom: 12,
      },
      userIdPill: {
        backgroundColor: '#E3F2FD',
        borderRadius: 20,
        paddingVertical: 6,
        paddingHorizontal: 16,
        shadowColor: '#000',
        shadowOffset: {width: 0, height: 1},
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      },
      userIdText: {
        fontSize: 14,
        fontWeight: '600',
        color: '#007AFF',
        textAlign: 'center',
      },
      focusedContent: {
        alignItems: 'center',
        marginVertical: 8,
      },
      focusedTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 4,
        color: '#333',
      },
      focusedDescription: {
        fontSize: 14,
        textAlign: 'left',
        alignSelf: 'stretch',
        color: '#555',
        paddingHorizontal: 8,
        lineHeight: 20,
      },

      helpRow: {
        marginTop: 12,
        borderTopWidth: 1,
        borderTopColor: '#eee',
        paddingTop: 8,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
      },
      postedByPill: {
        flex: 1,
        backgroundColor: '#E3F2FD',
        borderRadius: 999,
        paddingVertical: 6,
        paddingHorizontal: 12,
        color: '#1A5FB4',
        fontSize: 12,
        fontWeight: '700',
      },

      emptyStateCard: {
        marginHorizontal: 16,
        marginTop: 16,
        paddingVertical: 18,
        paddingHorizontal: 16,
        borderRadius: 12,
        backgroundColor: '#F8FAFC',
        borderWidth: 1,
        borderColor: '#E5E7EB',
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.08,
        shadowRadius: 6,
        elevation: 2,
      },
      emptyStateTitle: {
        fontSize: 16,
        fontWeight: '700',
        color: '#0F172A',
        textAlign: 'center',
      },
      emptyStateSubtitle: {
        marginTop: 4,
        fontSize: 13,
        fontWeight: '500',
        color: '#475569',
        textAlign: 'center',
      },
      emptyStateZip: {
        fontWeight: '700',
        color: '#0A84FF',
      },
      emptyStateHint: {
        marginTop: 8,
        fontSize: 11,
        color: '#64748B',
        textAlign: 'center',
      },
      zipHeader: {
        paddingVertical: 15,
        paddingHorizontal: 10,
        backgroundColor: '#f9f9f9',
        borderBottomWidth: 1,
        borderBottomColor: '#eee',
        marginBottom: 10,
      },
      zipHeaderText: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#333',
        textAlign: 'center',
      },
      zipChangeLink: {
        marginTop: 6,
        fontSize: 12,
        fontWeight: '600',
        color: '#0A84FF',
        textAlign: 'center',
        textDecorationLine: 'underline',
      },
      zipEditRow: {
        marginHorizontal: 12,
        marginBottom: 10,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
      },
      zipInput: {
        flex: 1,
        height: 44,
        borderWidth: 1,
        borderColor: '#D1D5DB',
        borderRadius: 8,
        paddingHorizontal: 10,
        backgroundColor: '#FFFFFF',
        fontSize: 12,
      },
      zipSubmitButton: {
        paddingHorizontal: 10,
        paddingVertical: 8,
        borderRadius: 8,
        backgroundColor: '#0A84FF',
      },
      zipSubmitButtonPressed: {
        opacity: 0.85,
      },
      zipSubmitText: {
        fontSize: 12,
        fontWeight: '600',
        color: '#FFFFFF',
      },
      zipCancelButton: {
        paddingHorizontal: 10,
        paddingVertical: 8,
        borderRadius: 8,
        backgroundColor: '#E5E7EB',
      },
      zipCancelButtonPressed: {
        opacity: 0.85,
      },
      zipCancelText: {
        fontSize: 12,
        fontWeight: '600',
        color: '#111827',
      },
    });

    export default Live;
